<template>
  <div>
    <div>
       <el-date-picker
       value-format="yyyy-MM-dd"
      v-model="startDate"
      type="date"
      placeholder="选择开始日期">
    </el-date-picker>
     <el-date-picker
      value-format="yyyy-MM-dd"
      v-model="endDate"
      type="date"
      placeholder="选择结束日期">
    </el-date-picker>
      <el-input style="width:200px" placeholder="输入查找信息" v-model="search"></el-input>
      <el-button @click="getpage(1)">筛选</el-button>
      <el-button @click="exportState" type="warning">导出</el-button>
    </div>
    <el-divider></el-divider>
    <div>
      <el-table :data="list"  >
        <el-table-column align="center" label="用户名">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>用户名: {{ scope.row.username }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.username }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" label="真实姓名" >
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.realName }}</span>
          </template>
        </el-table-column>
         <el-table-column align="center" label="操作时间" >
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.loginTime }}</span>
          </template>
        </el-table-column>
         <el-table-column align="center" label="IP" >
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.ip }}</span>
          </template>
        </el-table-column>
       <el-table-column align="center" label="应用名" >
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>应用名: {{ scope.row.appName }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag type="success" size="medium">{{ scope.row.appName }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" label="所属医院" >
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.orgName }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page @givePageIndex="getpage" :index="page" :pageSize="pageSize" :total="total"></page>
  </div>
</template>

<script>
import treeSelect from "../../components/treeSelect";
import page from "../../components/pages"
export default {
  components: {
    treeSelect,page
  },
  mounted() {
    this.load();
  },
  data() {
    return {
      startDate:'',
      endDate:'',
      search: "",
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
    };
  },
  methods: {
    exportState(){
      let obj = {
        search: this.search,
        startTime:this.startDate,
        endTime:this.endDate
      };
      this.$api.exportStateLogin(this.search,this.startDate,this.endDate,'Bearer '+sessionStorage.getItem("access_token"))
      // window.open(process.env.VUE_APP_API_URL+'/login-log/export?search='+this.search+'&startTime='+this.startTime+'&endDate='+this.endDate,'_self')
      // this.$api.exportStateLogin(obj).then(res=>{
      //   console.log(res)
      //   const blob = new Blob([res.data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}) // 处理文档流（res.data为返回的文档流）
      //   const fileName = '登录统计' // 下载时的文件名
      //   const elink = document.createElement('a')
      //   elink.download = fileName
      //   elink.style.display = 'none'
      //   elink.href = URL.createObjectURL(blob)
      //   document.body.appendChild(elink)
      //   elink.click()
      //   URL.revokeObjectURL(elink.href) // 释放URL 对象
      //   document.body.removeChild(elink)
      // }).catch(er=>{console.log(er)})
    },
    load() {
      let obj = {
        pageNo: this.page,
        pageSize: this.pageSize,
        search: this.search,
        startTime:this.startDate,
        endTime:this.endDate
      };
      console.log(obj)
      this.$api.stateLogin(obj).then(res => {
        console.log(res);
        if (res.data.code == 200) {
          this.list = res.data.data.records;
          this.page = res.data.data.current;
          this.pageSize = res.data.data.size;
          this.total = res.data.data.total;
        }
      });
    },
    getpage(x){//分页
    console.log(x)
      this.page=x
      this.load()
    }
  }
};
</script>

<style scoped>
</style>